import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../assets/batteryFrame/empty.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-86a10e36")

_pushScopeId("data-v-86a10e36")
const _hoisted_1 = {
  class: "toc_ui__batteryHealthy_main",
  id: "batteryHealthy"
}
const _hoisted_2 = { class: "toc_ui__batteryHealthy_body" }
const _hoisted_3 = { class: "toc_ui__batteryHealthy_body_cont" }
const _hoisted_4 = { class: "ui__comTitle_main" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_left" }, "电池健康度检测", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 标准解读 ")
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-youjiantou" }, null, -1)
const _hoisted_8 = { class: "batteryHealthyCircle" }
const _hoisted_9 = { class: "circleitem circle1" }
const _hoisted_10 = { class: "circleCont" }
const _hoisted_11 = { class: "number" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "label" }, "电池健康度", -1)
const _hoisted_14 = { class: "sign" }
const _hoisted_15 = { class: "circleitem circle2" }
const _hoisted_16 = { class: "circleCont" }
const _hoisted_17 = { class: "number" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "label" }, "预估续航", -1)
const _hoisted_20 = { class: "batteryHealthyNum" }
const _hoisted_21 = { class: "batteryHealthyNumItem times" }
const _hoisted_22 = { class: "batteryHealthyNumItem_num" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "batteryHealthyNumItem_label" }, "循环充电次数", -1)
const _hoisted_25 = { class: "batteryHealthyNumItem del" }
const _hoisted_26 = { class: "batteryHealthyNumItem_num" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "batteryHealthyNumItem_label" }, "平均衰减率", -1)
const _hoisted_29 = { class: "batteryHealthyRadar" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createTextVNode("雷达图"),
  /*#__PURE__*/_createVNode("i", { class: "iconfont icon-youjiantou" })
], -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "empty"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("p", null, "暂无数据", -1)
const _hoisted_35 = { class: "batteryHealthyTable" }
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"batteryHealthyTable_tr th\" data-v-86a10e36><div class=\"batteryHealthyTable_trCol col1\" data-v-86a10e36>项目</div><div class=\"batteryHealthyTable_trCol col2\" data-v-86a10e36>实测值</div><div class=\"batteryHealthyTable_trCol col3\" data-v-86a10e36>预报警阈值</div><div class=\"batteryHealthyTable_trCol col4\" data-v-86a10e36>状态</div></div>", 1)
const _hoisted_37 = { class: "batteryHealthyTable_tr" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "batteryHealthyTable_trCol col1" }, "单体欠压", -1)
const _hoisted_39 = { class: "batteryHealthyTable_trCol col2" }
const _hoisted_40 = { class: "batteryHealthyTable_trCol col3" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("u")
const _hoisted_43 = /*#__PURE__*/_createVNode("sub", null, "i", -1)
const _hoisted_44 = { class: "batteryHealthyTable_trCol col4" }
const _hoisted_45 = { class: "batteryHealthyTable_tr" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "batteryHealthyTable_trCol col1" }, "单体过压", -1)
const _hoisted_47 = { class: "batteryHealthyTable_trCol col2" }
const _hoisted_48 = { class: "batteryHealthyTable_trCol col3" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("u")
const _hoisted_51 = /*#__PURE__*/_createVNode("sub", null, "i", -1)
const _hoisted_52 = { class: "batteryHealthyTable_trCol col4" }
const _hoisted_53 = { class: "batteryHealthyTable_tr" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "batteryHealthyTable_trCol col1" }, "电压差异", -1)
const _hoisted_55 = { class: "batteryHealthyTable_trCol col2" }
const _hoisted_56 = { class: "batteryHealthyTable_trCol col3" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("U")
const _hoisted_59 = /*#__PURE__*/_createVNode("sub", null, "max", -1)
const _hoisted_60 = /*#__PURE__*/_createTextVNode("-U")
const _hoisted_61 = /*#__PURE__*/_createVNode("sub", null, "min", -1)
const _hoisted_62 = { class: "batteryHealthyTable_trCol col4" }
const _hoisted_63 = { class: "batteryHealthyTable_tr" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "batteryHealthyTable_trCol col1" }, "电池过温", -1)
const _hoisted_65 = { class: "batteryHealthyTable_trCol col2" }
const _hoisted_66 = { class: "batteryHealthyTable_trCol col3" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/_createTextVNode("T")
const _hoisted_69 = /*#__PURE__*/_createVNode("sub", null, "i", -1)
const _hoisted_70 = { class: "batteryHealthyTable_trCol col4" }
const _hoisted_71 = { class: "batteryHealthyTable_tr" }
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "batteryHealthyTable_trCol col1" }, "温度差异", -1)
const _hoisted_73 = { class: "batteryHealthyTable_trCol col2" }
const _hoisted_74 = { class: "batteryHealthyTable_trCol col3" }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = /*#__PURE__*/_createTextVNode("T")
const _hoisted_77 = /*#__PURE__*/_createVNode("sub", null, "max", -1)
const _hoisted_78 = /*#__PURE__*/_createTextVNode("-T")
const _hoisted_79 = /*#__PURE__*/_createVNode("sub", null, "min", -1)
const _hoisted_80 = { class: "batteryHealthyTable_trCol col4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_gauge = _resolveComponent("gauge")
  const _component_radar = _resolveComponent("radar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", {
            class: "titleSlot",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goCarInfo && _ctx.goCarInfo(...args)))
          }, [
            _hoisted_6,
            _hoisted_7
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_gauge, {
              bgColor: "#D1F1E7",
              dataColor: _ctx.state.batterysoh.dataColor,
              dataShadowColor: _ctx.state.batterysoh.dataShadowColor,
              gaugeId: "gauge1",
              data: _ctx.getData(null, 'soh') === '-' ? 64 : _ctx.getData(null, 'soh'),
              total: 100
            }, null, 8, ["dataColor", "dataShadowColor", "data"]),
            _createVNode("div", _hoisted_10, [
              _createVNode("p", _hoisted_11, [
                _createVNode("b", null, _toDisplayString(_ctx.getData(null, 'soh')), 1),
                (_ctx.getData(null, 'soh') !== '-')
                  ? (_openBlock(), _createBlock("span", _hoisted_12, "%"))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_13,
              _createVNode("p", _hoisted_14, [
                _createVNode("img", {
                  src: require(`../../../../../assets/batteryFrame/${_ctx.state.batterysoh.class}.png`)
                }, null, 8, ["src"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_gauge, {
              bgColor: "#E8F3FF",
              dataColor: ["#E5F1FF","#5DAEFD"],
              dataShadowColor: "#5AA9FD",
              gaugeId: "gauge2",
              data: _ctx.getData(null, 'soh') === '-' ? 64 : _ctx.getData(null, 'soh'),
              total: 100
            }, null, 8, ["data"]),
            _createVNode("div", _hoisted_16, [
              _createVNode("p", _hoisted_17, [
                _createVNode("b", null, _toDisplayString(_ctx.getData(null, 'kmRemain')), 1),
                (_ctx.getData(null, 'kmRemain') !== '-')
                  ? (_openBlock(), _createBlock("span", _hoisted_18, "km"))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_19
            ])
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("b", null, _toDisplayString(_ctx.getData(null, 'numberOfCycles')), 1),
              (_ctx.getData(null, 'numberOfCycles') !== '-')
                ? (_openBlock(), _createBlock("span", _hoisted_23, "次"))
                : _createCommentVNode("", true)
            ]),
            _hoisted_24
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode("b", null, _toDisplayString(_ctx.getData(null, 'annualAverageDecayRate')), 1),
              (_ctx.getData(null, 'annualAverageDecayRate') !== '-')
                ? (_openBlock(), _createBlock("span", _hoisted_27, "%"))
                : _createCommentVNode("", true)
            ]),
            _hoisted_28
          ])
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode("div", {
            class: "batteryHealthyRadar_title",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goCarInfo && _ctx.goCarInfo(...args)))
          }, [
            _hoisted_30
          ]),
          (_ctx.state.isShowRadar)
            ? (_openBlock(), _createBlock("div", _hoisted_31, [
                _createVNode(_component_radar, { renderData: _ctx.renderData }, null, 8, ["renderData"])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_32, [
                _hoisted_33,
                _hoisted_34
              ]))
        ]),
        _createVNode("div", _hoisted_35, [
          _hoisted_36,
          _createVNode("div", _hoisted_37, [
            _hoisted_38,
            _createVNode("div", _hoisted_39, _toDisplayString(_ctx.getData(_ctx.cellUnder, 'minMonoCellVoltage')), 1),
            _createVNode("div", _hoisted_40, [
              (_ctx.getData(_ctx.cellUnder, 'alarm') !== '-')
                ? (_openBlock(), _createBlock("span", _hoisted_41, [
                    _hoisted_42,
                    _hoisted_43
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.getData(_ctx.cellUnder, 'alarm')), 1)
            ]),
            _createVNode("div", _hoisted_44, [
              _createVNode("span", {
                class: ["batteryScore", {'error': _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '3',
                                'warn': _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '1' || _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '2',
                                'good': _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '0'
                            }]
              }, _toDisplayString(_ctx.transScore(_ctx.getData(_ctx.cellUnder, 'cellUnderVoltage'))), 3)
            ])
          ]),
          _createVNode("div", _hoisted_45, [
            _hoisted_46,
            _createVNode("div", _hoisted_47, _toDisplayString(_ctx.getData(_ctx.cellOver, 'maxMonoCellVoltage')), 1),
            _createVNode("div", _hoisted_48, [
              (_ctx.getData(_ctx.cellOver, 'alarm') !== '-')
                ? (_openBlock(), _createBlock("span", _hoisted_49, [
                    _hoisted_50,
                    _hoisted_51
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.getData(_ctx.cellOver, 'alarm')), 1)
            ]),
            _createVNode("div", _hoisted_52, [
              _createVNode("span", {
                class: ["batteryScore", {'error': _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '3',
                                'warn': _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '1' || _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '2',
                                'good': _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '0'
                            }]
              }, _toDisplayString(_ctx.transScore(_ctx.getData(_ctx.cellOver, 'cellOverVoltage'))), 3)
            ])
          ]),
          _createVNode("div", _hoisted_53, [
            _hoisted_54,
            _createVNode("div", _hoisted_55, _toDisplayString(_ctx.getData(_ctx.difference, 'voltageDifferenceValue')), 1),
            _createVNode("div", _hoisted_56, [
              (_ctx.getData(_ctx.difference, 'alarm') !== '-')
                ? (_openBlock(), _createBlock("span", _hoisted_57, [
                    _hoisted_58,
                    _hoisted_59,
                    _hoisted_60,
                    _hoisted_61
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.getData(_ctx.difference, 'alarm')), 1)
            ]),
            _createVNode("div", _hoisted_62, [
              _createVNode("span", {
                class: ["batteryScore", {'error': _ctx.getData(_ctx.difference, 'voltageDifference') === '3',
                                'warn': _ctx.getData(_ctx.difference, 'voltageDifference') === '1' || _ctx.getData(_ctx.difference, 'voltageDifference') === '2',
                                'good': _ctx.getData(_ctx.difference, 'voltageDifference') === '0'
                            }]
              }, _toDisplayString(_ctx.transScore(_ctx.getData(_ctx.difference, 'voltageDifference'))), 3)
            ])
          ]),
          _createVNode("div", _hoisted_63, [
            _hoisted_64,
            _createVNode("div", _hoisted_65, _toDisplayString(_ctx.getData(_ctx.overTemperature, 'highestTemperature')), 1),
            _createVNode("div", _hoisted_66, [
              (_ctx.getData(_ctx.overTemperature, 'alarm') !== '-')
                ? (_openBlock(), _createBlock("span", _hoisted_67, [
                    _hoisted_68,
                    _hoisted_69
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.getData(_ctx.overTemperature, 'alarm')), 1)
            ]),
            _createVNode("div", _hoisted_70, [
              _createVNode("span", {
                class: ["batteryScore", {'error': _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '3',
                                'warn': _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '1' || _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '2',
                                'good': _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '0'
                            }]
              }, _toDisplayString(_ctx.transScore(_ctx.getData(_ctx.overTemperature, 'batteryOverTemperature'))), 3)
            ])
          ]),
          _createVNode("div", _hoisted_71, [
            _hoisted_72,
            _createVNode("div", _hoisted_73, _toDisplayString(_ctx.getData(_ctx.temperatureDifference, 'temperatureDifferenceValue')), 1),
            _createVNode("div", _hoisted_74, [
              (_ctx.getData(_ctx.temperatureDifference, 'alarm') !== '-')
                ? (_openBlock(), _createBlock("span", _hoisted_75, [
                    _hoisted_76,
                    _hoisted_77,
                    _hoisted_78,
                    _hoisted_79
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.getData(_ctx.temperatureDifference, 'alarm')), 1)
            ]),
            _createVNode("div", _hoisted_80, [
              _createVNode("span", {
                class: ["batteryScore", {'error': _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '3',
                                'warn': _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '1' || _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '2',
                                'good': _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '0'
                            }]
              }, _toDisplayString(_ctx.transScore(_ctx.getData(_ctx.temperatureDifference, 'temperatureDifference'))), 3)
            ])
          ])
        ])
      ])
    ])
  ]))
})